<template>
  <div class="border border-card-border rounded bg-white">
    <div class="border-b border-card-border flex items-center p-x-4 p-y-3">
      <span class="fz0 svg-white-dart">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.28634 4C8.22907 4 7.3304 4.72241 7.03965 5.71237H4.63436C4.26432 5.71237 4 6.00669 4 6.38127C4 6.75585 4.29075 7.05017 4.66079 7.05017H7.06608C7.3304 8.04013 8.25551 8.76254 9.31277 8.76254C10.3965 8.76254 11.2952 8.04013 11.5859 7.05017H18.3392C18.7093 7.05017 19 6.75585 19 6.38127C19 6.00669 18.7093 5.71237 18.3392 5.71237H11.5859C11.2687 4.72241 10.37 4 9.28634 4ZM9.31277 5.33779C9.86784 5.33779 10.3436 5.79264 10.3436 6.38127C10.3436 6.9699 9.86784 7.42475 9.31277 7.42475C8.75771 7.42475 8.28194 6.9699 8.28194 6.38127C8.28194 5.79264 8.75771 5.33779 9.31277 5.33779Z" fill="#2C2C2C"/><path d="M14.2423 9.61374C13.185 9.61374 12.2863 10.3361 11.9956 11.3261H4.66079C4.26432 11.3261 4 11.6204 4 11.995C4 12.3696 4.29075 12.6639 4.66079 12.6639H11.9956C12.2599 13.6539 13.185 14.3763 14.2423 14.3763C15.326 14.3763 16.2247 13.6539 16.5154 12.6639H18.3392C18.7093 12.6639 19 12.3696 19 11.995C19 11.6204 18.7093 11.3261 18.3392 11.3261H16.5154C16.2247 10.3361 15.326 9.61374 14.2423 9.61374ZM14.2687 10.9515C14.8238 10.9515 15.2996 11.4064 15.2996 11.995C15.2996 12.5836 14.8238 13.0385 14.2687 13.0385C13.7137 13.0385 13.2379 12.5836 13.2379 11.995C13.2379 11.4064 13.6872 10.9515 14.2687 10.9515Z" fill="#2C2C2C"/><path d="M9.45815 15.7627C8.40088 15.7627 7.5022 16.4851 7.21145 17.4751H4.66079C4.26432 17.4751 4 17.7694 4 18.144C4 18.5185 4.29075 18.8129 4.66079 18.8129H7.23789C7.5022 19.8028 8.42731 20.5252 9.48458 20.5252C10.5683 20.5252 11.467 19.8028 11.7577 18.8129H18.3392C18.7093 18.8129 19 18.5185 19 18.144C19 17.7694 18.7093 17.4751 18.3392 17.4751H11.7313C11.4405 16.4851 10.5419 15.7627 9.45815 15.7627ZM9.48458 17.1005C10.0396 17.1005 10.5154 17.5553 10.5154 18.144C10.5154 18.7326 10.0396 19.1874 9.48458 19.1874C8.92951 19.1874 8.45374 18.7326 8.45374 18.144C8.48018 17.5553 8.92951 17.1005 9.48458 17.1005Z" fill="#2C2C2C"/></svg>
      </span>
      <div class="m-r-auto m-l-3 fw500 fz14 text-dark">Filter</div>
      <div class="flex items-center p-x-2 p-y-0.5 fz12 text-white bg-blue rounded-full cursor-pointer" v-if="filtersCounter" @click="clearAll">
        {{filtersCounter}}
        <svg class="m-l-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.05373 3.92533C2.81022 3.68421 2.81022 3.29329 3.05373 3.05217C3.29724 2.81106 3.69206 2.81106 3.93557 3.05217L8.94574 7.97332C9.18925 8.21444 9.18925 8.60536 8.94574 8.84647C8.70223 9.08759 8.30741 9.08759 8.0639 8.84647L3.05373 3.92533Z" fill="white"/><path d="M8.06398 3.15356C8.3075 2.91245 8.70231 2.91245 8.94582 3.15356C9.18933 3.39468 9.18933 3.7856 8.94582 4.02672L3.93565 8.94786C3.69214 9.18898 3.29732 9.18898 3.05381 8.94786C2.8103 8.70675 2.8103 8.31582 3.05381 8.07471L8.06398 3.15356Z" fill="white"/></svg>
      </div>
    </div>

    <filter-block class="border-b border-card-border" title="Types" id="types" :isEmpty="!filters.types.length" @on-clear="filters.types = []">
      <b-form-checkbox
        v-for="(type, i) in clientsType"
        v-model="filters.types"
        :key="type.id"
        :value="type"
        :class="{
          'm-b-3': i < clientsType.length - 1
        }"
      >
        <div class="fz13 text-dark">{{ type.name }}</div>
      </b-form-checkbox>
    </filter-block>

    <filter-block class="border-b border-card-border" title="Subtypes" id="subtypes" :isEmpty="!filters.subtypes.length" @on-clear="$refs.dropSubtype.clearAll()">
      <counterparties-drop-filter 
        ref="dropSubtype"
        :list="subtypeDepend"
        :isMultiple="true"
        @select="list => filters.subtypes = list"
      />
    </filter-block>
    <filter-block class="border-b border-card-border" title="Brokers" id="brokers" :isEmpty="!filters.brokers.length" @on-clear="$refs.dropBroker.clearAll()">
      <counterparties-drop-filter 
        ref="dropBroker"
        :list="brokers"
        :isMultiple="true"
        @select="list => filters.brokers = list"
      />
    </filter-block>

    <filter-block class="border-b border-card-border" title="Ports" id="ports" :isEmpty="!filters.ports.length" @on-clear="filters.ports = []">
      <async-select-port
        v-model="filters.ports"
        id="ports"
        :isMultiple="true"
        :allowEmpty="true"
      />
    </filter-block>

    <filter-block class="border-b border-card-border" title="Common name" id="charter_name" :isEmpty="!filters.charter_name.length" @on-clear="filters.charter_name = []">
      <async-select
          v-model="filters.charter_name"
          :allowEmpty="true"
          :closeOnSelect="false"
          :isMultiple="true"
          label=""
          url="/client/dropdown"
          :placeholder="''"
          :params="{ordering: 'charter_name', is_archived: false, is_charter_name: true}"
          watchKey="charter_name"
      ></async-select>
    </filter-block>

    <filter-block title="Tags" id="tags" :isEmpty="!filters.tags.length" @on-clear="$refs.tagDrop.clearData()">
      <div class="tag_selector">
        <task-list-tag-select class="tag_selector" ref="tagDrop" @changeSelectTag="selectTag"></task-list-tag-select>
      </div>
    </filter-block>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import filterBlock from "@/components/counterparties/filters/filterBlock"
import asyncSelectPort from "@/components/reuse/asyncSelectPort"
import taskListTagSelect from "@/components/tasks/tasks-list/task-list-tag-select"
import counterpartiesDropFilter from "@/components/counterparties/counterpartiesList/counterpartiesDropFilter"
import AsyncSelect from "@/components/reuse/asyncSelect";

export default {
  components: {
    AsyncSelect,
    filterBlock,
    asyncSelectPort,
    taskListTagSelect,
    counterpartiesDropFilter
  },
  props: {
    filters: Object
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      clientsType: state => state.counterpartiesType.clientsType,
      clientsSubtype: state => state.counterpartiesType.clientsSubtype,
      brokers: state => state.counterparties.brokers,
    }),
    filtersCounter() {
      let count = 0
      count += this.filters.ports.length
      count += this.filters.tags.length
      count += this.filters.types.length
      count += this.filters.subtypes.length
      count += this.filters.brokers.length
      return count
    },
    subtypeDepend() {
      let subtypes = this.clientsSubtype.filter(elem => {
        return this.filters.types.map(el=>el.id).indexOf(elem.parent_id) >= 0
      })
      return subtypes
    }
  },
  methods: {
    ...mapActions(['axiosGetClientsType', 'axiosGetClientsSubtype', 'axiosGetBrokers']),
    clearAll() {
      this.filters.ports = []
      this.filters.types = []
      this.$refs.dropSubtype.clearAll()
      this.$refs.dropBroker.clearAll()
      this.$refs.tagDrop.clearData()
    },
    selectTag() {
      this.filters.tags = this.$refs.tagDrop.getTagsForAxios()
    },
  },
  async beforeMount() {
    this.axiosGetClientsType()
    await this.axiosGetClientsSubtype()
    let broketTypeId = this.clientsSubtype.find(el=>el.name == 'Broker')
    if(broketTypeId){
      this.axiosGetBrokers(broketTypeId.id)
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./src/components/style-element/bootstrap";
  @import "./src/components/style-element/checkbox";
</style>

<style lang="scss">
  .tag_selector{
    position: relative;
    .hide-drop{
      display: flex !important;
    }
    .button-drop{
      width: 100% !important;
      height: 36px !important;
    }
  }
</style>